import SignIn from "./pages/auth/SignIn";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Admin from "./protectedRoutes/admin";
import Consultant from "./protectedRoutes/consultant";
import PrivateRoute from "./protectedRoutes/protector";
// import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/call-animations.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FullScreenLoader, { SocketProvider } from "./utils/Socket.Provider";
import DeleteAccountPage from "./pages/delete-account/DeleteAccount";
import CsaePolicyPage from "./pages/delete-account/CsaePolicyPage";
import { BecomeConsultant } from "./pages/local/BecomeConsultant";
import { OtpVerification } from "./pages/local/OtpVerification";
import { ApplicationSuccess } from "./pages/local/ApplicationSuccess";
import { BecomeConsultantLanding } from "./pages/local/BecomeConsultantLanding";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [userRole, setUserRole] = React.useState(undefined);
  const [isLoading, setIsLoading] = React.useState(true);

  // Get user role from localStorage
  React.useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userAuth"))?.role;
    setUserRole(token || null);
    setIsLoading(false);
  }, []);

  // Create a portal container for call UI only for consultant users
  // React.useEffect(() => {
  //   const isConsultant = userRole === "consultant";

  //   if (!document.getElementById("call-ui-portal") && isConsultant) {
  //     const portalContainer = document.createElement("div");
  //     portalContainer.id = "call-ui-portal";
  //     portalContainer.style.position = "fixed";
  //     portalContainer.style.top = "0";
  //     portalContainer.style.left = "0";
  //     portalContainer.style.width = "100%";
  //     portalContainer.style.height = "100%";
  //     portalContainer.style.zIndex = "9999";
  //     portalContainer.style.pointerEvents = "none";
  //     document.body.appendChild(portalContainer);
  //   }
  // }, [userRole]);

  if (isLoading) {
    return <FullScreenLoader />;
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/csae-policy" element={<CsaePolicyPage />} />

        {/* BecomeConsultant sequence routes */}
        <Route
          path="/become-consultant"
          element={<BecomeConsultantLanding />}
        />

        <Route
          path="/become-consultant/verify-otp"
          element={<OtpVerification />}
        />
        <Route path="/become-consultant/form" element={<BecomeConsultant />} />
        <Route
          path="/become-consultant/form/:id"
          element={<BecomeConsultant />}
        />
        <Route
          path="/become-consultant/success"
          element={<ApplicationSuccess />}
        />
        {/* <Route path="/become-consultant/:id" element={<BecomeConsultant />} /> */}

        {/* Default route for root */}
        <Route
          path="/"
          element={
            userRole === "admin" ? (
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            ) : userRole === "consultant" ? (
              <PrivateRoute>
                <SocketProvider>
                  <Consultant />
                </SocketProvider>
              </PrivateRoute>
            ) : (
              <SignIn />
            )
          }
        />

        {/* Protected wildcard routes for authenticated users */}
        {userRole === "admin" && (
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          />
        )}

        {userRole === "consultant" && (
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <SocketProvider>
                  <Consultant />
                </SocketProvider>
              </PrivateRoute>
            }
          />
        )}
      </Routes>

      {/* Call UI container for consultants */}
      {/* {userRole === "consultant" && (
        <div id="call-ui-root" style={{ position: "relative", zIndex: 9999 }} />
      )} */}

      {/* Global ToastContainer */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
}

export default App;
